<h1 mat-dialog-title>
    {{ this.inventurEintrag.artikel_me }}
    <br />
    Menge: {{ this.inventurEintrag.menge }}
</h1>
<div mat-dialog-actions>
    <button mat-button (click)="close()">Abbrechen</button>
    <button mat-flat-button (click)="save()" color="accent">Löschen</button>
</div>
